module.exports = __webpack_public_path__ + "static/media/help_agreements.ad02f15d.png";